import React, { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import { api } from "@/lib/api";
import { EmptyState } from "@/components/common/EmptyState";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { WorkItemRow } from "@/components/workspace/WorkItemRow";
import { WorkItemDialog } from "@/components/workspace/WorkItemDialog";
import { AssignWorkDialog } from "@/components/workspace/team/AssignWorkDialog";

const STATUS_FILTERS = [
  ["open", "Open work"], ["blocked", "Blocked"], ["awaiting_review", "Awaiting review"], ["completed", "Completed"], ["all", "Everything"],
];

export function AssignmentsTab({ orgId, people, ownerFilter, onOwnerFilter, canEdit, onChanged }) {
  const [status, setStatus] = useState("open");
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(null);
  const [assigning, setAssigning] = useState(false);
  const load = () => {
    const q = `${status !== "all" ? `&status=${status}` : ""}${ownerFilter !== "all" ? `&owner_id=${ownerFilter}` : ""}`;
    return api.get(`/workspace/team/actions?org_id=${orgId}${q}`).then((r) => setRows(r.data));
  };
  useEffect(() => { setRows(null); load(); }, [orgId, status, ownerFilter]); // eslint-disable-line react-hooks/exhaustive-deps
  const changed = () => { load(); onChanged(); };
  const team = people.filter((p) => p.in_scope);

  return (
    <div data-testid="assignments-tab">
      <div className="mb-4 flex flex-wrap items-center gap-2">
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="h-9 w-[170px] bg-white" data-testid="assign-status-filter"><SelectValue /></SelectTrigger>
          <SelectContent>{STATUS_FILTERS.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={ownerFilter} onValueChange={onOwnerFilter}>
          <SelectTrigger className="h-9 w-[200px] bg-white" data-testid="assign-owner-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Everyone in my team</SelectItem>
            {team.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
          </SelectContent>
        </Select>
        {canEdit && (
          <Button onClick={() => setAssigning(true)} className="ml-auto bg-[#FFB000] text-[#0B1729] hover:bg-[#E69E00]" data-testid="assign-work-btn">
            <Icons.Plus size={16} className="mr-1.5" /> Assign work
          </Button>
        )}
      </div>
      {rows === null ? <Icons.Loader2 className="mx-auto mt-8 animate-spin text-[#FFB000]" /> : rows.length === 0 ? (
        <EmptyState icon="ListChecks" title="No work matches" description="Assign work linked to a priority, improvement or KPI to see it here." testId="assignments-empty" />
      ) : (
        <div className="space-y-2" data-testid="assignments-list">{rows.map((a) => <WorkItemRow key={a.id} a={a} onOpen={setOpen} showOwner />)}</div>
      )}
      {open && <WorkItemDialog actionId={open.id} onClose={() => setOpen(null)} onChanged={changed} />}
      {assigning && (
        <AssignWorkDialog orgId={orgId} people={people} defaultOwner={ownerFilter !== "all" ? ownerFilter : ""}
          onClose={() => setAssigning(false)} onSaved={() => { setAssigning(false); changed(); }} />
      )}
    </div>
  );
}
